/**
 * A global namespace for `scrollHeight` property.
 */
const scrollHeight = "scrollHeight";
export default scrollHeight;
